import { Component, OnInit, Input, ElementRef, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-left-menu",
  templateUrl: "./left-menu.component.html",
  styleUrls: ["./left-menu.component.less"],
})
export class LeftMenuComponent implements OnInit {
  readonly TYPE_ENDPOINT = "ENDPOINT";
  readonly TYPE_TESTCASE = "TESTCASE";
  readonly TYPE_TESTSUITE = "TESTSUITE";
  readonly TYPE_MASTERSUITE = "MASTERSUITE";
  readonly TYPE_EXECUTION_RESULTS = "EXECUTION_RESULTS";
  readonly TYPE_GOPHER = "GOPHER";
  readonly TYPE_ENDPOINT_CREATE = "NEW_ENDPOINT";
  readonly TYPE_TESTCASE_CREATE = "NEW_TESTCASE";

  @Input() details: any = {};
  @Input() type: string;
  setSideMenu = [];
  wikiLink:any;
  @ViewChild('header') header;

  constructor(private httpClient: HttpClient, private activatedRoute: ActivatedRoute, private _el: ElementRef) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe(() => {
      this.getMenus();
    });
    this.getWikiLink();
  }

  getMenus() {
    this.httpClient.get("assets/data/sidemenu.json").subscribe((data) => {
      this.setSideMenu = this.replaceLinks(this.type, this.details, data);
    });
  }

  replaceLinks(type, obj, data): Array<any> {
    let menuItems = [];
    if (type === this.TYPE_ENDPOINT) {
      data.endpoint.forEach((elem) => {
        let specific;
        let value;
        /* For specific page */
        if (elem.specific == undefined) {
          menuItems.push(elem);
          /* If specific to WEB endpoint value.link.replace('{id}', obj.id) */
        } else if (elem.specific) {
          specific = elem.specific.replace(/[{()}]/g, "");
          if (specific.includes(".")) {
            value = specific.split(".").reduce(function (prev, cur) {
              return prev[cur];
            }, obj);

            if (value) {
              menuItems.push(elem);
            } else {
              return;
            }
          } else if (obj[specific]) {
            menuItems.push(elem);
          }
        }
        /* If access is restricted */
        if (elem.denied != undefined) {
          let deniedArray = elem.denied.substring(1, elem.denied.length - 1).split(",");
          for(let i=0; i < deniedArray.length; i++) {
            if (obj[deniedArray[i]]) {
              menuItems.pop();
              return;
            }
          }
        }
        if(obj.webEndPoint && elem.name === "Prompt Association" && !this.details?.project?.projectConfig?.record) {
          menuItems.pop();
        }
      });
    } else if (type === this.TYPE_TESTCASE) {
      data.testcase.forEach((elem) => {
        let specific;
        let value;
        /* For specific page */
        if (elem.specific == undefined) {
          menuItems.push(elem);
          /* If specific to WEB endpoint value.link.replace('{id}', obj.id) */
        } else if (elem.specific) {
          specific = elem.specific.replace(/[{()}]/g, "");
          if (specific.includes(".")) {
            value = specific.split(".").reduce(function (prev, cur) {
              return prev[cur];
            }, obj);

            if (value) {
              menuItems.push(elem);
            } else {
              return;
            }
          } else if (obj[specific]) {
            menuItems.push(elem);
          }
        }
        /* If access is restricted */
        if (elem.denied != undefined) {
          let deniedArray = elem.denied.substring(1, elem.denied.length - 1).split(",");
          for(let i=0; i < deniedArray.length; i++) {
            if (obj[deniedArray[i]]) {
              menuItems.pop();
              return;
            }
          }
        }
      });
    } else if (type === this.TYPE_TESTSUITE) {
      data.testsuite.forEach((elem) => {
        let specific;
        let value;
        /* For specific page */
        if (elem.specific == undefined) {
          menuItems.push(elem);
          /* If specific to WEB endpoint value.link.replace('{id}', obj.id) */
        } else if (elem.specific) {
          specific = elem.specific.replace(/[{()}]/g, "");
          if (specific.includes(".")) {
            value = specific.split(".").reduce(function (prev, cur) {
              return prev[cur];
            }, obj);

            if (value) {
              menuItems.push(elem);
            } else {
              return;
            }
          } else if (obj[specific]) {
            menuItems.push(elem);
          }
        }
        /* If access is restricted */
        if (elem.denied != undefined) {
          let deniedArray = elem.denied.substring(1, elem.denied.length - 1).split(",");
          for(let i=0; i < deniedArray.length; i++) {
            if (obj[deniedArray[i]]) {
              menuItems.pop();
              return;
            }
          }
        }
      });
    }

    if (type === this.TYPE_MASTERSUITE) menuItems = data.mastersuite;
    if (type === this.TYPE_EXECUTION_RESULTS) menuItems = data.executionResults;
    if (type === this.TYPE_GOPHER) menuItems = data.gopher;
    if (type === this.TYPE_ENDPOINT_CREATE) menuItems = data.createEndpoint;
    if (type === this.TYPE_TESTCASE_CREATE) menuItems = data.createTestcase;

    menuItems.map(function (value) {
      return (value.link = value.link.replace("{id}", obj.id));
    });
    if (type === this.TYPE_EXECUTION_RESULTS) {
      menuItems.map((value) => {
        value.queryParams.executedBy = JSON.parse(localStorage.getItem("user")).id;
      });
    }
    return menuItems;
  }

  getWikiLink(){
    switch(this.type.toLowerCase()) {
      case 'endpoint':
        this.wikiLink = 'https://wiki.corp.adobe.com/display/Relay/03.+API+Endpoint+Set+Up';
        break;
      case 'testcase':
        this.wikiLink = 'https://wiki.corp.adobe.com/display/Relay/05.Test+Case+Set+Up';
        break;  
      case 'new_testcase':
        this.wikiLink = 'https://wiki.corp.adobe.com/display/Relay/05.Test+Case+Set+Up';
        break;  
      case 'testsuite':
        this.wikiLink = 'https://wiki.corp.adobe.com/pages/viewpage.action?pageId=3050222591';
        break;
      case 'mastersuite':
        this.wikiLink = 'https://wiki.corp.adobe.com/pages/viewpage.action?pageId=3271454782';
        break;
      default:
          this.wikiLink = this.wikiLink;
        break;
    }
  }

  expandMenu(reference: HTMLElement) {
    reference.classList.remove("collapsed");
  }

  collapseMenu(reference: HTMLElement){
    reference.classList.add("collapsed");
  }
}
